import { useEffect, useRef, useState } from 'react';
import Footer from '../common/footer';
import BigBen from './big-ben';
import CreateMaterial from './create-material';
const imagesURLs = [
  '20221227-influence-home-image.svg',
  '20221227-hand-complete.svg',
  '20221227-big-light-bulb-line-1.svg',
  '20221227-big-light-bulb-line-2.svg',
  '20221227-big-light-bulb-line-3.svg',
  '20221227-big-light-bulb-line-4.svg',
  '20221227-big-light-bulb-line-5.svg',
  '202212121-bigben-background.svg',
];

const MainHome = () => {
  const counter = useRef(0);
  const preloadImages = useRef();
  const [preload, setPreload] = useState(false);
  const preloadImage = (url) => {
    let img = new Image();
    let src = `${process.env.NEXT_PUBLIC_CDNURL}/images/influence/${url}`;
    img.onload = () => {
      let newCounter = counter.current + 1;
      counter.current = newCounter;
      if (newCounter === imagesURLs.length) {
        setPreload(true);
      }
    };
    img.src = src;
  };

  preloadImages.current = () => {
    for (let i = 0; i < imagesURLs.length; i++) {
      let url = imagesURLs[i];
      preloadImage(url);
    }
  };

  useEffect(() => {
    preloadImages.current();
  }, []);

  return (
    <>
      <div className='bg-blue-dark text-white'>
        <div className='bg-gray-home text-blue-dark relative'>
          {preload && (
            <>
              <img
                src={`${process.env.NEXT_PUBLIC_CDNURL}/images/influence/20221227-influence-home-image.svg`}
                alt='hand holding a megaphone'
                className='hidden lg:block top-[12vh] absolute left-[-20%] xl:left-[-15%] 2xl:left-[-8%] 4xl:left-0 2xl:top-[9vh] w-[480px]'
              />

              <div className='absolute left-[-35%] xl:left-[-19%] 2xl:left-[-12%] 4xl:left-0 top-[240px] w-[550px] h-[358px] hidden lg:block z-[49]'>
                <div className='h-full w-full relative'>
                  <img
                    src={`${process.env.NEXT_PUBLIC_CDNURL}/images/influence/20221227-hand-complete.svg`}
                    alt='hand'
                    className='absolute left-0 top-[35px] w-[517px]'
                  />
                  <img
                    src={`${process.env.NEXT_PUBLIC_CDNURL}/images/influence/20221227-big-light-bulb-line-1.svg`}
                    alt='line 1'
                    className='light-bulb-line light-bulb-line-1 absolute left-[422px] top-[55px] w-[28px]'
                  />
                  <img
                    src={`${process.env.NEXT_PUBLIC_CDNURL}/images/influence/20221227-big-light-bulb-line-2.svg`}
                    alt='line 1'
                    className='light-bulb-line light-bulb-line-2 absolute left-[440px] top-[17px] w-[21px]'
                  />
                  <img
                    src={`${process.env.NEXT_PUBLIC_CDNURL}/images/influence/20221227-big-light-bulb-line-3.svg`}
                    alt='line 1'
                    className='light-bulb-line light-bulb-line-3 absolute left-[481px] top-0 w-[11px]'
                  />
                  <img
                    src={`${process.env.NEXT_PUBLIC_CDNURL}/images/influence/20221227-big-light-bulb-line-4.svg`}
                    alt='line 1'
                    className='light-bulb-line light-bulb-line-4 absolute left-[512px] top-[18px] w-[22px]'
                  />
                  <img
                    src={`${process.env.NEXT_PUBLIC_CDNURL}/images/influence/20221227-big-light-bulb-line-5.svg`}
                    alt='line 1'
                    className='light-bulb-line light-bulb-line-5 absolute left-[524px] top-[56px] w-[26px]'
                  />
                </div>
              </div>
            </>
          )}

          <div className='pt-8 lg:pb-14 container relative lg:min-h-[710px] '>
            <section className='pt-14 pb-24 text-center px-7 lg:px-0'>
              <h1 className='text-[2.05em] lg:text-4xl font-bold mb-5 max-w-md text-center mx-auto leading-snug'>
                Have your message heard by policymakers
              </h1>
              <p className='text-gray-dark/80 text-xl max-w-md mx-auto lg:text-xl'>
                Influence the political landscape by presenting lobbying material to relevant stakeholders.
              </p>
              <CreateMaterial />
            </section>
            {/* <img src={`${process.env.NEXT_PUBLIC_CDNURL}/images/influence/big-ben-influence.svg`} alt="big ben" className="hidden lg:block absolute right-0 bottom-0 h-[92%]"/> */}
            {preload && <BigBen />}
          </div>
        </div>

        <section>
          <div className='bg-purple-100 lg:pl-14 py-12 lg:py-0'>
            <div className='lg:container xl:pr-32'>
              <div className='lg:flex justify-between items-center'>
                <div className='grow px-8 lg:pr-20 py-10'>
                  <blockquote className='font-medium text-2xl relative lg:pl-24 lg:pr-20 pb-5'>
                    <img
                      className='lg:absolute top-0 left-0 w-10 lg:w-16 mb-4 lg:mb-0'
                      src={`${process.env.NEXT_PUBLIC_CDNURL}/images/quote_open_white.png`}
                      alt='blockquote left'
                    />
                    PolicyInfluence allows us to raise the profile of our organisation with members of parliament and
                    peers who can help us to achieve real change for animals.
                    <img
                      className='block mt-4 mr-0 ml-auto lg:absolute bottom-0 right-0 w-10 lg:w-16 lg:m-0'
                      src={`${process.env.NEXT_PUBLIC_CDNURL}/images/quote_close_white.png`}
                      alt='blockquote right'
                    />
                  </blockquote>
                  <p className='text-lg mt-3 lg:mt-6 mb-5 lg:pl-24'>
                    Emily Wilson, Head of Programmes & Campaigns, FOUR PAWS UK, London
                  </p>
                </div>
                <img
                  className='-mt-24 max-w-[270px] hidden lg:block relative z-10'
                  src={`${process.env.NEXT_PUBLIC_CDNURL}/images/influence/four-paws.svg`}
                  alt='blockquote image'
                />
              </div>
            </div>
          </div>
        </section>

        <div className='container'>
          <section className='pt-12 pb-8 lg:py-20'>
            <h2 className='text-center text-2xl font-bold lg:mb-12'>Why use PolicyInfluence?</h2>
            <div className='lg:flex gap-6 py-6'>
              <div className='flex-1 m-6 bg-white p-8 text-blue-dark rounded-md lg:m-0'>
                <p className='text-xl font-bold pb-4'>It&apos;s quick</p>
                <hr className='border-t border-purple-100 mb-4 w-24 border-2' />
                <p>
                  Your lobbying material will be live on PolicyInfluence within minutes, where it will be immediately
                  available to hundreds of MPs, peers and their staff. Some parliamentarians may also receive your
                  content by email, depending on their interests and email alert settings.
                </p>
              </div>
              <div className='flex-1 m-6 bg-white p-8 text-blue-dark rounded-md lg:m-0'>
                <p className='text-xl font-bold pb-4'>It&apos;s powerful</p>
                <hr className='border-t border-purple-100 mb-4 w-24 border-2' />
                <p>
                  Add your existing lobbying material or create new content from scratch. It will then automatically be
                  available to all parliamentarians, and shared directly with those for whom it is most relevant,
                  depending on their interests and email alert settings.
                </p>
              </div>
              <div className='flex-1 m-6 bg-white p-8 text-blue-dark rounded-md lg:m-0'>
                <p className='text-xl font-bold pb-4'>It&apos;s free</p>
                <hr className='border-t border-purple-100 mb-4 w-24 border-2' />
                <p>
                  PolicyInfluence is free of charge to all organisations and policymakers. (Some functionality - such as
                  the ability to restrict lobbying material to policymakers only - is available on PolicyMogul, which
                  also offers tailored political monitoring, stakeholder mapping and analytics).
                </p>
              </div>
            </div>
          </section>
        </div>

        <section className='py-28 px-8 text-center bg-purple-100 lg:px-0'>
          <h2 className='text-2xl font-bold max-w-2xl mx-auto mb-8'>
            Try the UK&apos;s most advanced political monitoring, research and stakeholder mapping platform
          </h2>
          <p className='max-w-2xl mx-auto mb-8 text-lg'>Join PolicyMogul and get closer to the people in power.</p>
          <a
            className='bg-yellow-100 border border-yellow-100 text-blue-dark font-bold rounded-small px-7 py-3 transition-colors  hover:bg-yellow-hover'
            href={`${process.env.NEXT_PUBLIC_POLICYMOGUL_BASE_URL}/register?utm_source=policyinfluence-homepage`}
            target={'_blank'}
            rel='noopener noreferrer'
          >
            Start your free PolicyMogul trial
          </a>
        </section>

        <section className='bg-white py-14 text-center'>
          <h2 className='px-8 text-2xl max-w-2xl mx-auto mb-6 text-purple-100'>
            New to lobbying? Read our lobbying 101 guide
          </h2>
          <a
            className='bg-purple-100 text-white rounded-full py-3 px-16 text-lg hover:bg-purple-hover transition-colors'
            href={`${process.env.NEXT_PUBLIC_WORDPRESS_SITE_INFLUENCE}/guides`}
          >
            Get the guide
          </a>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default MainHome;
